import { render } from "./PageFilters.vue?vue&type=template&id=bc60f2fc"
import script from "./PageFilters.vue?vue&type=script&lang=js"
export * from "./PageFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__